import SharedProcessingTimeSection, { type ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const russellvilleOptions: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

const russellvilleEmergencyDescription =
  "Arkansas residents have access to the Arkansas Passport Center at 400 N College Ave, Hot Springs, AR 71901 — the state's own passport agency. Russellville sits in the Arkansas River Valley between the Ozark and Ouachita National Forests, about 95 miles from Hot Springs (~1.5 hours via AR-7). Arkansas Tech University sends hundreds of students abroad every semester — a Wonder Boy discovering an expired passport 48 hours before a flight to Florence can drive to Hot Springs or use a registered courier. The Arkansas Nuclear One power plant employs hundreds of engineers and contractors who travel internationally for industry conferences and equipment training — when your next assignment is in France and your passport is expired, the Arkansas Passport Center is your in-state solution. During spring tornado season (March–May), AR-7 between Russellville and Hot Springs passes through some of the most scenic terrain in the Ouachitas — but travel is manageable year-round. In-state agency. Help is 95 miles away through the Ouachita foothills.";

const russellvilleDisclaimer =
  "Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing. The Arkansas Passport Center is at 400 N College Ave, Hot Springs, AR 71901.";

export default function RussellvilleProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Russellville"
      headingExtra="AR"
      introText="Russellville travelers — Arkansas Tech students and faculty, Arkansas Nuclear One professionals, Tyson Foods executives, and Arkansas River Valley families — have several options for getting a passport fast. Here is how they compare, and why most River Valley residents choose a U.S. Department of State registered passport courier for predictable, professional processing."
      options={russellvilleOptions}
      emergencyDescription={russellvilleEmergencyDescription}
      disclaimerText={russellvilleDisclaimer}
    />
  );
}